import { getMinorCodeList } from "src/apis/commonCodeApi"
import { getCompanyList } from "src/apis/companyApi"
import { getOrganizationList } from "src/apis/organizaApi"

export const getMinorCdList = async (majorCd: string) => {
	const response = await getMinorCodeList(majorCd);
	return response.data.data.sort((a, b) => a.dispSeq - b.dispSeq);
}

export const getCompCdList = async () => {
	const response = await getCompanyList();
	return response.data.data;
}

export const getOrgCdList = async () => {
	const response = await getOrganizationList();
	return response.data.data;
}